export const LOGIN_ACTION = 'auth/login'
export const FORGOT_PASSWORD_ACTION = 'auth/forgotPassword'
export const UPDATE_USER_ACTION = 'auth/updateUser'
export const CHANGE_PASSWORD_ACTION = 'auth/changePassword'
export const GET_IMAGE_URL = 'auth/getImageUrl'
